import { SeoConfig } from './seo.config';

export const defaultSeoConfig: SeoConfig = {
  seo: {
    structuredData: {
      disableInDevMode: true,
    },
  },
};
